import { ProjectCustomerEmailDTO } from '../../domain/project/ProjectDTO';
import { ProjectCustomerEmail } from '../../domain/project/projectCustomerEmail/ProjectCustomerEmail';
import { ProjectCustomerEmailItemMapper } from './ProjectCustomerEmailItemMapper';

export class ProjectCustomerEmailMapper {
  static toDomain(props: ProjectCustomerEmailDTO): ProjectCustomerEmail {
    const {
      stop_created,
      route_started,
      stop_approaching,
      stop_completed,
      stop_canceled,
      pickup_created,
      pickup_approaching,
      pickup_completed,
      pickup_canceled,
    } = props;

    return ProjectCustomerEmail.create({
      stop_created: stop_created ? ProjectCustomerEmailItemMapper.toDomain(stop_created) : undefined,
      route_started: route_started ? ProjectCustomerEmailItemMapper.toDomain(route_started) : undefined,
      stop_approaching: stop_approaching ? ProjectCustomerEmailItemMapper.toDomain(stop_approaching) : undefined,
      stop_completed: stop_completed ? ProjectCustomerEmailItemMapper.toDomain(stop_completed) : undefined,
      stop_canceled: stop_canceled ? ProjectCustomerEmailItemMapper.toDomain(stop_canceled) : undefined,
      pickup_created: pickup_created ? ProjectCustomerEmailItemMapper.toDomain(pickup_created) : undefined,
      pickup_approaching: pickup_approaching ? ProjectCustomerEmailItemMapper.toDomain(pickup_approaching) : undefined,
      pickup_completed: pickup_completed ? ProjectCustomerEmailItemMapper.toDomain(pickup_completed) : undefined,
      pickup_canceled: pickup_canceled ? ProjectCustomerEmailItemMapper.toDomain(pickup_canceled) : undefined,
    });
  }

  static toRepository(projectCustomerEmail: ProjectCustomerEmail): ProjectCustomerEmailDTO {
    return {
      ...(projectCustomerEmail?.stop_created
        ? {
            stop_created: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.stop_created),
          }
        : {}),
      ...(projectCustomerEmail?.route_started
        ? {
            route_started: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.route_started),
          }
        : {}),
      ...(projectCustomerEmail?.stop_approaching
        ? {
            stop_approaching: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.stop_approaching),
          }
        : {}),
      ...(projectCustomerEmail?.stop_completed
        ? {
            stop_completed: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.stop_completed),
          }
        : {}),
      ...(projectCustomerEmail?.stop_canceled
        ? {
            stop_canceled: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.stop_canceled),
          }
        : {}),

      ...(projectCustomerEmail?.pickup_created
        ? {
            pickup_created: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.pickup_created),
          }
        : {}),
      ...(projectCustomerEmail?.pickup_approaching
        ? {
            pickup_approaching: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.pickup_approaching),
          }
        : {}),

      ...(projectCustomerEmail?.pickup_completed
        ? {
            pickup_completed: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.pickup_completed),
          }
        : {}),

      ...(projectCustomerEmail?.pickup_canceled
        ? {
            pickup_canceled: ProjectCustomerEmailItemMapper.toRepository(projectCustomerEmail?.pickup_canceled),
          }
        : {}),
    };
  }
}
